const isHomePage = window.location.pathname === "/";
// Analytics
export const GTM_ID = "GTM-TJ4D9B8Z";
export const GTM_ID_STAGING = "GTM-5HKSNP2F";

// Microsoft Clarity
export const CLARITY_PROJECT_ID = "quirckm1s4";

// API
export const API_BASE_URL =
  // "https://australia-southeast1-staible-returns.cloudfunctions.net";
  "https://lexi-prod-lexi-1-mcdr62tc5a-ts.a.run.app";
export const API_BASE_URL_DEV =
  "https://lexi-dev-lexi-1-mcdr62tc5a-ts.a.run.app";
export const API_BASE_URL_STAGING =
  "https://lexi-staging-lexi-1-mcdr62tc5a-ts.a.run.app";

// App Settings
export const APP_NAME = "Lexi.tips";

export const TIP_LINGO = [
  {
    favourite: [
      "I love this one...",
      "This is my favourite.",
      "I'd go for this...",
    ],
    nextFavourite: [
      "But this one's really close too!",
      "Keep an eye on ",
      "This guy will give him a run for his money!",
    ],
    outsider: [
      "Whoa! Check out this horse, might upset alot of people!",
      "If this one wins though, cha-ching!",
      "But there is a good chance this outsider steals the show!",
    ],
  },
];

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "How it works", href: isHomePage ? "#howitworks" : "/#howitworks" },
  { label: "Features", href: isHomePage ? "#features" : "/#features" },
  { label: "Pricing", href: isHomePage ? "#pricing" : "/#pricing" },
  // {
  //   label: "Testimonials",
  //   href: isHomePage ? "#testimonials" : "/#testimonials",
  // },
  { label: "Contact", href: isHomePage ? "#contact" : "/#contact" },
];

export enum SendgridStatus {
  PENDING_CONFIRMATION = "pending_confirmation",
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export const ReqRoles = ["admin", "developer"];
